import wechat from '@/asset/img/wechat_service.webp'
import Modal from '@/components/Modal'
import Text from '@/components/Text'
import { errorText, secondaryText } from '@/constant'
import { useMobileView } from '@/hooks'
import { ImageIcon } from '@/icon'
import { AuthContext } from '@/layout/Auth'
import { ClearOutlined } from '@mui/icons-material'
import { Stack } from '@mui/material'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { PlainCard, Row } from './components'

const Onboarding: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authInfo } = useContext(AuthContext)
  const isMobile = useMobileView()
  const [showFollow, setShowFollow] = useState<boolean>(
    !isMobile &&
      localStorage.getItem('followedService') !== '1' &&
      authInfo?.auth &&
      !authInfo?.hasFollowService &&
      location?.pathname?.indexOf('/console/app') === -1,
  )

  const closeFollow = useCallback(() => {
    localStorage.setItem('followedService', '1')
    setShowFollow(false)
  }, [])

  useEffect(() => {
    setShowFollow(
      !isMobile &&
        localStorage.getItem('followedService') !== '1' &&
        authInfo?.auth &&
        !authInfo?.hasFollowService &&
        location?.pathname?.indexOf('/console/app') === -1,
    )
  }, [authInfo?.auth, authInfo?.hasFollowService, isMobile])

  return (
    <>
      {children}
      <Modal open={showFollow} onClose={closeFollow} width={'360px'}>
        <PlainCard>
          <Row sx={{ justifyContent: 'space-between' }}>
            <Text weight='bold'>请关注以下公众号，用于接收事件告警</Text>
            <ClearOutlined sx={{ cursor: 'pointer' }} onClick={closeFollow} />
          </Row>
          <Stack
            sx={{
              alignItems: 'center',
            }}
          >
            <ImageIcon src={wechat} sx={{ width: '200px' }} />
            <Text size='xs' sx={{ color: secondaryText, margin: '8px' }}>
              长亭百川云
            </Text>
            <Text size='xs' sx={{ color: errorText, margin: '8px', fontSize: '12px' }}>
              要使用微信告警通知，需要关注此号
            </Text>
          </Stack>
        </PlainCard>
      </Modal>
    </>
  )
}

export default Onboarding
